/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { PaymentCurrencies } from '@mta/vela-api-types'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import React from 'react'

import { Button } from '@/components/ui/Button'
import { Link } from '@/i18n/navigation'
import { subtotalAtom, taxAtom, totalAtom } from '@/store/basket'
import { formatPrice } from '@/utils/price-formatting'

/** A description of the available properties for this component. */
type BasketTotalsSummaryProps = {
  /** Whether the checkout button should be visible at the bottom of the summary view. */
  showCheckoutButton: boolean
}

const BasketTotalsSummary: React.FC<BasketTotalsSummaryProps> = ({ showCheckoutButton }) => {
  const t = useTranslations('BasketTotalsSummary')
  const subtotal = useAtomValue(subtotalAtom)
  const tax = useAtomValue(taxAtom)
  const total = useAtomValue(totalAtom)
  const currency = subtotal?.currency ?? 'GBP'

  return (
    <div className='w-full max-w-sm ml-auto p-6 border rounded-lg shadow-xs bg-gray-50'>
      <h2 className='text-xl font-semibold mb-4'>{t('basketSummary')}</h2>
      <div className='space-y-2'>
        <div className='flex justify-between'>
          <span>{t('subtotal')}</span>
          <span className='font-medium'>
            {subtotal
              ? formatPrice(subtotal.amount, PaymentCurrencies[subtotal.currency])
              : formatPrice(0, PaymentCurrencies[currency])}
          </span>
        </div>
        <div className='flex justify-between'>
          <span>{t('tax')}</span>
          <span className='font-medium'>
            {tax
              ? formatPrice(tax.amount, PaymentCurrencies[tax.currency])
              : subtotal
                ? formatPrice(0, PaymentCurrencies[subtotal.currency])
                : formatPrice(0, PaymentCurrencies[currency])}
          </span>
        </div>
        <div className='flex justify-between text-lg font-bold border-t pt-2 mt-2'>
          <span>{t('total')}</span>
          <span className='font-medium'>
            {total
              ? formatPrice(total.amount, PaymentCurrencies[total.currency])
              : formatPrice(0, PaymentCurrencies[currency])}
          </span>
        </div>
      </div>
      {showCheckoutButton && (
        <Button asChild variant={'primary'} rounded={'lg'} fullWidth className={'mt-4'}>
          <Link href={'/checkout'}>
            {t('proceedToCheckout')}
          </Link>
        </Button>
      )}
    </div>
  )
}

export { BasketTotalsSummary }
